import { Login } from "@mui/icons-material";
import { Avatar, Box, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import React, { memo } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

const Image = styled("img")({
  maxWidth: "100%",
  height: "3rem",
});

function Header(props: { drawerWidth?: number, isLoggedIn?: boolean }) {
  const navigate = useNavigate();
  const location = useLocation();

  const profileMenu = React.useMemo(() => [
    { pageTitle: 'Profile', title: "Profile", path: '/profile', icon: <PersonIcon /> },
    { pageTitle: 'Logout', title: "Home", path: '/', icon: <LogoutIcon /> },
  ], []);

  // for Avatar menu
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  
  React.useEffect(() => {
    // Find the item in navigation that matches the current path
    const currentItem = profileMenu.find(item => item.path === location.pathname);

    // If a matching item is found, update the page title
    if (currentItem) {
      document.title = `${currentItem.title}`; // Update title
    }
  }, [location, profileMenu]);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar color="transparent" sx={{
      backdropFilter: "blur(6px)", borderBottom: 1, backgroundColor: "rgba(255,255,255,0.8)", borderColor: "hsl(215,15%,92%)", width: { sm: `calc(100% - ${props.drawerWidth}px)` },
      ml: { sm: `${props.drawerWidth}px`, }, height: "65px"
    }} elevation={0}>
      {!props.isLoggedIn && <Container sx={{ px: 0 }}>
        <Toolbar
          sx={{
            px: { md: 0 },
            justifyContent: props.isLoggedIn ? "end" : "space-between",
            alignItems: "center",
            fontWeight: "500",
          }}
        >
          <Image src="/assets/images/bidirectional.png" alt="Logo" />
          <Button startIcon={<Login />} variant="text" onClick={(() => { navigate('/rateFee') })} sx={{ display: { xs: "none", sm: "flex" } }}>
            Login
          </Button>
        </Toolbar>
      </Container>}
      {/* <Container> */}
      {props.isLoggedIn && <Toolbar
        sx={{
          // px: { md: 0 },
          justifyContent: props.isLoggedIn ? "end" : "space-between",
          alignItems: "center",
          fontWeight: "500",
        }}
      >
        {!props.isLoggedIn && <Image src="/assets/images/bidirectional.png" alt="Logo" />}
        {!props.isLoggedIn && <Button startIcon={<Login />} variant="text" onClick={(() => { navigate('/rateFee') })} sx={{ display: { xs: "none", sm: "flex" } }}>
          Login
        </Button>}
        {props.isLoggedIn && <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt="Admin" src="/assets/images/profile-image.webp" sx={{ boxShadow: 3 }} />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {profileMenu.map((item) => (
              <MenuItem key={item.title} component={NavLink} title={item.title} to={item.path} onClick={handleCloseUserMenu} sx={{ py: 0 }}>
                <Typography variant="body1" sx={{ textAlign: 'center', display: "flex", alignItems: 'center' }}>
                  <span style={{ marginRight: 8, marginTop: 8 }}>{item.icon}</span>
                  {item.pageTitle}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>}
      </Toolbar>}
      {/* </Container> */}
    </AppBar>
  );
}

export default memo(Header);
